import { interfaces } from "inversify";
import { RateLimiter } from "~/modules/ratelimiter/RateLimiter/RateLimiter";
import { rateLimiterMapRTTI } from "~/modules/ratelimiter/ratelimiter.rtti";

export function cleanupRateLimiters(container: interfaces.Container) {
    const rateLimiters = container.get<Map<string, RateLimiter>>(rateLimiterMapRTTI);
    rateLimiters.forEach((value) => value.cleanup());
    rateLimiters.clear();
}
